'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgCopyPaste } from '@common/icon';
import { useClipboard } from '@/hooks/useClipboard';
interface CopyButtonProps {
  text: string;
}
export const CopyButton = t0 => {
  const $ = _c(6);
  const {
    text
  } = t0;
  const copy = useClipboard();
  let t1;
  if ($[0] !== copy || $[1] !== text) {
    t1 = () => copy({
      value: text,
      message: "\uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4"
    });
    $[0] = copy;
    $[1] = text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SvgCopyPaste className="size-16 cursor-pointer" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="flex w-full items-center justify-start"><button aria-label={"\uB2F5\uBCC0 \uBCF5\uC0AC"} className="rounded-xsmall p-6 text-Gray-550 transition-colors hover:bg-Gray-200 hover:text-Gray-900" onClick={t1}>{t2}</button></div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};